import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import mainReducer from '../reducers'


const logger = store => next => action => {
  console.log('dispatching', action);
  let result = next(action);
  console.log('next state', store.getState());
  return result;
}

var middleware = [thunk];

var enableLogging = false;
if(enableLogging) {
    middleware.push(logger);
}

let store = createStore(mainReducer, {}, applyMiddleware(...middleware));
export default store;



// WEBPACK FOOTER //
// ./src/state/store.js